import React, { useState } from "react";
import LoadTermsAndConditions from "./termsAndConditions/LoadTermsAndConditions";
import HasPermissionTo from "../../common/HasPermissionTo";
import { withTranslation } from "react-i18next";
import SubNav from "../../shared/subnav/SubNav";
import TranslationDetails from "../translations/TranslationDetails";

const NscBusinessSettings = (props) => {
  const [selectedTab, setSelectedTab] = useState(props.startingTab);

  const handleTabChange = (event, newSelectedTab) => {
    setSelectedTab(newSelectedTab);
  };

  const getTabs = () => {
    return [
      {
        menuName: props.t("ProgressBar.termsConditions"),
        enabled: true,
        id: "empMembership",
      },
      {
        menuName: props.t("ProgressBar.translations"),
        enabled: true,
        id: "translations",
        hide: !props.user.permissions.rolePermissions.hasOwnProperty(
          "translationsTab"
        ),
      },
    ];
  };

  return (
    <div>
      <SubNav
        dashboard={false}
        selectedTab={selectedTab}
        title={props.t("GlobalNavBar.settings")}
        action={handleTabChange}
        tabs={getTabs()}
        restrictDropdown={props.restrictDropdown}
        {...props}
      />
      <div className="pageWrapper">
        {selectedTab === 0 && <LoadTermsAndConditions {...props} />}
        <HasPermissionTo
          perform={["translationsTab"]}
          permissions={props.user.permissions.rolePermissions}
          condition={selectedTab === 1}
          render={() => <TranslationDetails {...props} />}
        />
      </div>
    </div>
  );
};

export default withTranslation("emp")(NscBusinessSettings);
